var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { isPlaceboTest } from "./ABTests.mjs";
import analytics from "./analytics/index.mjs";
import { trackABTestAssigned } from "./analytics/events.mjs";
class ExternalABTests {
  constructor(opts) {
    __publicField(this, "source");
    this.opts = opts;
  }
  setSource(source) {
    if (this.source) {
      throw new Error("ExternalABTestsSource already set!");
    }
    this.source = source;
    this.updateUserProperties();
    this.source.setOnChangedHandler((...args) => this.onChanged(...args));
  }
  getPayloadProperties() {
    if (!this.source) {
      return {};
    }
    return this.getTests("sourceAB_");
  }
  getABTag() {
    var _a;
    return ((_a = this.source) == null ? void 0 : _a.getABTag()) || "";
  }
  getAssignedNonPlaceboTestIds() {
    var _a;
    return Object.keys(((_a = this.source) == null ? void 0 : _a.getABTests()) || {}).filter(
      (testId) => !isPlaceboTest(testId)
    );
  }
  onChanged(changeEvents) {
    const internalTests = this.opts.getInternalABTestIDs();
    for (const changeEvent of changeEvents || []) {
      const isDuplicatePlaceboTest = internalTests.includes(changeEvent.testId) && isPlaceboTest(changeEvent.testId);
      if (changeEvent.bucketId && !isDuplicatePlaceboTest) {
        trackABTestAssigned({
          bucket: changeEvent.bucketId,
          newPlayersOnly: changeEvent.newUsersOnly,
          test: changeEvent.testId
        });
      }
    }
    this.updateUserProperties();
  }
  updateUserProperties() {
    const internalABTag = this.opts.getInternalABTag();
    const externalABTag = this.source.getABTag();
    const props = {
      ABtag: internalABTag && externalABTag ? `${internalABTag},${externalABTag}` : internalABTag || externalABTag,
      ...this.getTests("abTest_")
    };
    analytics.setUserProperties(props, analytics.toDefault);
  }
  getTests(prefix) {
    const externalTests = this.source.getABTests();
    const internalTests = this.opts.getInternalABTestIDs();
    const result = {};
    for (const testId in externalTests) {
      if (internalTests.includes(testId)) {
        if (isPlaceboTest(testId)) {
          continue;
        }
        throw new Error(
          `Test id '${testId}' is present in both internal and external tests!`
        );
      }
      const bucketId = externalTests[testId];
      if (!bucketId) {
        continue;
      }
      result[prefix + testId] = bucketId;
    }
    return result;
  }
}
export {
  ExternalABTests
};
